let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("GHK1P")).then(() => parcelRequire('57oKS'));